var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"height-percent-100 p15"},[(_vm.detailObj)?_c('carrierAbnormal',{attrs:{"detailObj":_vm.detailObj}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }